module.exports = __webpack_public_path__ + "static/media/datasheet_entData_row1_googleQRcode.e900f272.png";